import React from 'react';
import { StyleSheet, View } from 'react-native';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import ProgressBar from 'design-system/ProgressBar';
import { rem } from 'design-system/values';
import Text from 'design-system/Text';
import Squircle from 'design-system/Squircle';
import { IconMedal } from 'design-system/icons/IconMedal';
import { selectQuestsSummary } from 'features/quests/store/selectors';
import { useAppSelector } from 'store/hooks';
import useColors from 'hooks/useColors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const Quests = ({ style }) => {
    const { percentage, completed, total } = useAppSelector(selectQuestsSummary);
    const nav = useMainStackNavigation();
    const onPress = () => {
        nav.navigateDeprecated('Quests', { source: 'feed' });
    };
    const colors = useColors();
    return (<TouchableBounceCard noMarginBottom noMarginTop onDark style={[styles.card, style]} onPress={onPress}>
      <View style={styles.titleContainer}>
        <View>
          <Text Text-16>Quests</Text>
          <Text TextThin-14 Secondary>
            Unlock them all to become a pro
          </Text>
        </View>
        <Squircle color={colors.background.dark}>
          <IconMedal height={24} width={24}/>
        </Squircle>
      </View>

      <ProgressBar position={percentage} colors={colors.gradients.ultimate.colors}/>

      <View style={styles.progressTextContainer}>
        <Text TextThin-14 Secondary>
          {percentage}% completed
        </Text>
        <Text NumbersThin-14 Secondary>
          {completed}/{total}
        </Text>
      </View>
    </TouchableBounceCard>);
};
const styles = StyleSheet.create({
    card: {
        padding: rem(16),
        marginHorizontal: rem(16),
        gap: rem(16),
    },
    titleContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    progressTextContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
});
export default Quests;
